<div class="d-flex flex-column gap-3 p-3 position-relative">
    <app-spinner-overlay
        [showSpinner]="isLoading"
    >
    </app-spinner-overlay>
    @if (!rows.length && !isLoading) {
        <div
            class="vstack gap-3 align-items-center flex-grow-1 text-center p-4"
        >
            <span class="fw-semibold fs-5 text-dark-emphasis">
                No Customer Feedback
            </span>
            <span>
                Feedback from this customer's previous bookings will appear here.
            </span>
        </div>
    }
    @if (rows.length) {
        <div class="list-group list-group-flush border border-light rounded-2 overflow-hidden bg-light">
            @for (row of rows; track row.feedbackId) {
                <div class="list-group-item vstack gap-2 py-3">
                    <div class="hstack justify-content-between gap-3">
                        <span class="fw-semibold">
                            Booking on {{ row.startTime | dateTime : venue.timeZone : DateTime.DATETIME_MED_WITH_WEEKDAY }}
                        </span>
                        <span
                            class="feedback-badge"
                            appRatingStatus
                            [rating]="row.rating"
                        >
                            {{ row.rating }} / 5
                        </span>
                    </div>
                    <div class="hstack flex-wrap gap-2">
                        @if (row.food) {
                            <span
                                class="feedback-badge"
                                appRatingStatus
                                [rating]="row.food"
                            >
                                Food {{ row.food }} / 5
                            </span>
                        }
                        @if (row.service) {
                            <span
                                class="feedback-badge"
                                appRatingStatus
                                [rating]="row.service"
                            >
                                Service {{ row.service }} / 5
                            </span>
                        }
                        @if (row.atmosphere) {
                            <span
                                class="feedback-badge"
                                appRatingStatus
                                [rating]="row.atmosphere"
                            >
                                Atmosphere {{ row.atmosphere }} / 5
                            </span>
                        }
                    </div>
                    @if (row.comment) {
                        <span class="text-body-dark">
                            @let commentIsExpanded = expandedFeedbackCommentIds.has(row.feedbackId);
                            @let commentCanTruncate = row.comment.length > feedbackCommentPreviewLength;
                            {{ commentIsExpanded || !commentCanTruncate ? row.comment : (row.comment | slice: 0 : feedbackCommentPreviewLength) + '...' }}
                            @if (commentCanTruncate) {
                                <button
                                    class="btn btn-sm btn-link p-0 ms-1 lh-base"
                                    type="button"
                                    (click)="toggleFeedbackComment(row.feedbackId)"
                                >
                                    {{ commentIsExpanded ? 'Read less' : 'Read more' }}
                                </button>
                            }
                        </span>
                    }
                    @if (row.isRedirectedExternally) {
                        <span class="fst-italic text-body-secondary">
                            Customer was directed to an external platform after indicating they would like to leave a {{ row.rating }}/5 review.
                        </span>
                    }
                    <span class="small text-body-secondary">
                        Feedback left {{ row.feedbackDateCreated | dateTime : venue.timeZone : DateTime.DATE_MED_WITH_WEEKDAY }}
                    </span>
                </div>
            }
        </div>
    }
</div>
